import React from "react"
import { IconButton } from "@mui/material"
import Edit from "@mui/icons-material/Edit"
import { COLORS } from "../utils"
import { makeStyles } from "@mui/styles"

const useStyles = makeStyles(() => ({
  iconButton: {
    width: "24px",
    height: "24px",
    padding: 0,
    color: COLORS.PRIMARY_COLOR
  }
}))

const GenericEditIcon = ({ onEdit }) => {
  const classes = useStyles()

  return (
    <IconButton
      onClick={onEdit}
      disableRipple
      size="small"
      className={classes.iconButton}
    >
      <Edit />
    </IconButton>
  )
}

export default GenericEditIcon